<template>
  <div class="navigation">
    <div class="navigation__slider" :class="{'navigation__slider--visible':visible}">
      <div class="title navigation__slider__title">menu</div>
      <router-link class="navigation__slider__link" to="/" @click.native="visible=false">Home</router-link>
      <router-link class="navigation__slider__link" :key="`nav--${item}`" v-for="item in userNavigationItems" :to="`/${item}`" @click.native="visible=false">
        {{ $t(`nav.${item}`) }}
      </router-link>
      <div class="navigation__slider__toggle" @click="visible=!visible">
        <fa-icon icon="chevron-left" v-if="visible"></fa-icon>
        <fa-icon icon="chevron-right" v-else></fa-icon>
      </div>
      <div class="navigation__slider__version">
        <span>v.{{ version }}</span>
      </div>
      <div class="navigation__slider__overlay" @click="visible=false"></div>
    </div>
    <div class="navigation__mobile">
      <fa-icon class="navigation__mobile__toggle" :icon="visible?'times':'bars'" @click="visible=!visible"></fa-icon>
      <div class="navigation__mobile__menu" :class="{'navigation__mobile__menu--visible':visible}">
        <div class="navigation__mobile__menu__content">
          <router-link class="navigation__mobile__menu__content__link" to="/" @click.native="visible=false">Home</router-link>
          <router-link class="navigation__mobile__menu__content__link" :key="`nav--${item}`" v-for="item in userNavigationItems" :to="`/${item}`" @click.native="visible=false">
            {{ $t(`nav.${item}`) }}
          </router-link>
        </div>
        <div class="navigation__mobile__menu__version">
          <span>v.{{ version }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigation",

  data() {
    return {
      visible: false,
      user: this.$store.state.auth.user,
      version: process.env.VERSION
    };
  },

  computed: {
    userNavigationItems() {
      let bedrijf = parseInt(this.user.BEDRIJF);
      if(bedrijf === 9){ //student
        bedrijf = parseInt(this.user.BEDRIJFPORTAAL);
      }
      let items = ['profile'];
      let extraArray = [];
      if(bedrijf === 8){ //onderaannemer
        extraArray = ['trips','trips-select','drivers','fleet','invoice','contracts','logos','links'];
      }
      else if(bedrijf === 88){ //onderaannemer chauffeur
        extraArray = ['trips', 'logos','links'];
      }
      else if(bedrijf === 3){ //HES & Billo
        extraArray = ['trips','trips-confirm','trips-history','logos','time-schedule','repairs','worktime','leave-requests','contracts','links'];
      }
      else if(bedrijf === 1){ //V-tax
        extraArray = ['documents','fms','extra-hours','repairs','contracts','behaviour']
      }
      items.push(...extraArray);
      return items;
    }
  }
}
</script>
